/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Theme1StorePage from "./Theme1StorePage";
import Theme2StorePage from "./Theme2StorePage";
import Theme3StorePage from "./Theme3StorePage";
import { getTenantIdentityBySlug } from "./utils/storeApi";
import { buildImageUrl } from "./theme1/utils/theme1Helpers";

export default function UnifiedStorePage() {
  const { storeSlug: routeSlug } = useParams();

  const hostname = window.location.hostname;
  const isLocalhost =
    hostname === "localhost" || hostname === "127.0.0.1";

  const storeSlug = routeSlug || (!isLocalhost ? hostname.split(".")[0] : null);

  const [loading, setLoading] = useState(true);
  const [tenant, setTenant] = useState(null);
  const [error, setError] = useState(null);

  // تحديث عنوان الصفحة والأيقونة عند تحميل بيانات المتجر
  useEffect(() => {
    if (!tenant) return;

    document.title = tenant.storeName || "Madar Store";

    const faviconUrl = buildImageUrl(tenant.logo);

    if (faviconUrl) {
      const head = document.getElementsByTagName("head")[0];

      // أزل أي أيقونات قديمة
      head
        .querySelectorAll("link[rel='icon'], link[rel='shortcut icon']")
        .forEach(el => head.removeChild(el));

      const iconLink = document.createElement("link");
      iconLink.type = "image/png";
      iconLink.rel = "icon";
      iconLink.href = faviconUrl;
      head.appendChild(iconLink);

      const shortcut = document.createElement("link");
      shortcut.type = "image/png";
      shortcut.rel = "shortcut icon";
      shortcut.href = faviconUrl;
      head.appendChild(shortcut);
    }
  }, [tenant]);

  useEffect(() => {
    if (!storeSlug) {
      setError("⚠️ لم يتم تحديد رابط المتجر");
      setLoading(false);
      return;
    }

    const loadTenant = async () => {
      try {
        const res = await getTenantIdentityBySlug(storeSlug);

        if (!res.success || !res.data) {
          throw new Error("Tenant not found");
        }

        const t = res.data;

        const unifiedTenant = {
          tenantId: Number(t.tenantId),
          storeName: t.storeName || "",
          storeSlogan: t.storeSlogan || "",
          logo: t.logo || "",
          themeId: Number(t.themeId || 1),
          colorName: t.colorName || ""          // ← جديد

        };

        setTenant(unifiedTenant);
        setLoading(false);
      } catch (e) {
        console.error(e);
        setError("⚠️ خطأ أثناء تحميل المتجر");
        setLoading(false);
      }
    };

    loadTenant();
  }, [storeSlug]);

  if (loading) return <p>⏳ جاري تحميل المتجر...</p>;
  if (error) return <p>{error}</p>;
  if (!tenant) return null;

  switch (tenant.themeId) {
    case 1:
      return <Theme1StorePage tenantId={tenant.tenantId} tenant={tenant} />;
    case 2:
      return <Theme2StorePage tenantId={tenant.tenantId} tenant={tenant} />;
    case 3:
      return <Theme3StorePage tenantId={tenant.tenantId} tenant={tenant} />;
    default:
      return <Theme1StorePage tenantId={tenant.tenantId} tenant={tenant} />;
  }
}
